import React, { useEffect, useState } from "react";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import Header from "../../../components/Header/Header";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import {
  Grid,
  Button,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  // InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // Paper,
  TextField,
} from "@mui/material";
import DateRangePicker from "../../../components/DateRangePicker";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import moment from "moment";
// import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "@mui/material/TablePagination";
import "./outPutFormat.scss";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";

export default function DataPointDetails() {
  const Dispatch = useDispatch();
  const dataPoints = useSelector((state) => state?.admin?.dataPointDetail);
  const [dpPoint, setDpPoint] = useState(dataPoints?.data);
  const [file, setFile] = useState("");
  const [pageCount, setPageCount] = useState(dataPoints?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const apiStatus = useSelector((state) => state?.admin?.dataPointDetail);
  const [page, setPage] = useState(0);
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:charset=UTF-8";
  const fileExtension = ".xlsx";

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      file,
    };
    Dispatch(acts.getDpDetails(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Dispatch, rowsPerPage]);

  useEffect(() => {
    if (dataPoints?.data?.length > 0) {
      setDpPoint(dataPoints?.data);
    } else {
      setDpPoint([]);
    }
    setRowsPerPage(rowsPerPage);
    setPageCount(dataPoints?.total_count);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataPoints?.data, pageCount]);

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(dataPoints?.data);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "DPDetails" + fileExtension);
  };

  const filterByDate = (startDate, endDate, status) => {
    //Date filter
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";
    setSDate(formattedStartDate);
    setEDate(formattedEndDate);
    setPage(0);
    setRowsPerPage(100);
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      formattedStartDate,
      formattedEndDate,
      file,
    };
    Dispatch(acts.getDpDetails(data));
    setPageCount(dataPoints?.total_count);
  };

  const handleChange = (event) => {
    setPage(0);
    setFile(event.target.value);
  };

  const onSearch = (word) => {
    let result;
    if (word) {
      result = dataPoints?.data?.filter(function (el) {
        return (
          el?.file_name.toString().toLowerCase().indexOf(word.toLowerCase()) !==
          -1
        );
      });
    } else {
      result = dataPoints?.data;
    }
    setDpPoint([...result]);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    const data = {
      page: value + 1,
      page_size: rowsPerPage,
      formattedStartDate: sDate,
      formattedEndDate: eDate,
      file,
    };
    Dispatch(acts.getOutPutList(data));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader text="Data Point Details" />
            <Grid container spacing={2} className="dp-main-container">
              {/* <Grid container className="DataPointDetails-container"> */}
              <Grid item xs={3}>
                <TextField
                  id="searchInput"
                  placeholder="Search"
                  size="small"
                  variant="outlined"
                  fullWidth
                  inputProps={{ "aria-label": "search" }}
                  onChange={(event) => onSearch(event.target.value)}
                />
              </Grid>

              <Grid item xs={3} className="select-grid">
                <FormControl
                  fullWidth
                  size="small"
                  className="datapoint-multiple-controls"
                >
                  <InputLabel id="file-extension-label">
                    File Extension
                  </InputLabel>
                  <Select
                    labelId="file-extension-label"
                    value={file}
                    label="File Extension"
                    onChange={handleChange}
                    inputProps={{ "aria-label": "file-extension" }}
                  >
                    <MenuItem value="xlsx">xlsx</MenuItem>
                    <MenuItem value="csv">csv</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <DateRangePicker filterByDate={filterByDate} />
              </Grid>
              <Grid item xs={2} className="datapoint-btn-wrap">
                <Button
                  onClick={exportToExcel}
                  size="small"
                  variant="outlined"
                  className="download-btn"
                  startIcon={<FileDownloadIcon />}
                >
                  download
                </Button>
              </Grid>
            </Grid>
            <Box className="datapoint-map-wrap">
              {apiStatus?.loader ? (
                <DashboardTableSkaleton count={7} />
              ) : (
                <Box className="datapoint-table-container">
                  <TableContainer className="datapoint-map-container">
                    <Table
                      stickyHeader
                      className="table-output"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>File Name</TableCell>
                          <TableCell>File Extension</TableCell>
                          <TableCell>Data Points</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dpPoint?.map((list) => {
                          return (
                            <>
                              <TableRow key={list.id}>
                                <TableCell align="left">
                                  {list.file_name}
                                </TableCell>
                                <TableCell align="left">
                                  {list.file_extension}
                                </TableCell>
                                <TableCell align="left">
                                  {list.data_points}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}
            </Box>
            <Grid className="dataPointDetail1">
              <TablePagination
                component="div"
                rowsPerPageOptions={[100, 200, 300, 500]}
                count={parseInt(pageCount)}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
